/**
 * Constantes de identidad de la plataforma.
 *
 * Viven en su propio módulo, y no en `index.ts`, porque el barril reexporta a los demás módulos
 * del paquete: si `roles.ts` importara de `./index.js` para leer `ROLES`, se cerraría un ciclo
 * ESM que **compila y pasa el chequeo de tipos** pero revienta al ejecutar con
 * `ReferenceError: Cannot access 'ROLES' before initialization`.
 *
 * Regla del paquete: ningún módulo hijo importa del barril.
 */
/** Versión del formato de importación/exportación de cuestionarios (§10.1 de la especificación). */
export const CLICA_FORMAT_VERSION = 1;
/** Idiomas de interfaz soportados. El inglés es el idioma de reserva (principio V). */
export const LOCALES = ['es', 'ca', 'en'];
export const FALLBACK_LOCALE = 'en';
/** Roles de usuario (§3 de la especificación). */
export const ROLES = ['admin', 'teacher', 'student'];
/**
 * Letra, forma y color de cada opción de respuesta.
 * Los tres viajan siempre juntos: nunca se comunica una opción solo por color (principio IV).
 *
 * `onColor` es el color de la letra sobre la ficha, y está elegido midiendo el contraste, no a
 * ojo. Con blanco, B daba 3,87:1 y C daba 3,42:1: por debajo del 4,5:1 que exige AA para texto.
 * Con negro dan 5,43:1 y 6,14:1, y pasan en cualquier tamaño.
 *
 * Esto NO lo detecta una comprobación automática: el fondo de la ficha es un relleno de SVG, y la
 * herramienta remonta el árbol hasta el fondo de la página. Hay que medirlo a mano.
 */
export const ANSWER_TOKENS = [
    { letter: 'A', shape: 'diamond', color: '#0072B2', onColor: '#FFFFFF' }, // 5,19:1
    { letter: 'B', shape: 'triangle', color: '#D55E00', onColor: '#000000' }, // 5,43:1
    { letter: 'C', shape: 'square', color: '#009E73', onColor: '#000000' }, // 6,14:1
    { letter: 'D', shape: 'circle', color: '#E69F00', onColor: '#000000' }, // 9,32:1
];
/**
 * Cuánto texto admite una opción de respuesta.
 *
 * Ciento sesenta caracteres son dos líneas largas: caben una frase completa y una unidad, que es
 * lo que de verdad se escribe en una opción. Por encima de eso, el recuadro del móvil obliga a
 * encoger la letra hasta que deja de leerse desde el pupitre, y una opción que hay que leer con
 * detenimiento deja de medir lo que sabe quien responde y pasa a medir lo deprisa que lee.
 */
export const MAX_OPTION_LENGTH = 160;
/**
 * Cuánto texto admite un enunciado.
 *
 * Ochocientos caracteres son un párrafo largo, o unas doce líneas de código, que es el caso que
 * de verdad estira un enunciado (§9.2). Da margen de sobra sin permitir que una pregunta se
 * convierta en un texto de examen: proyectado a 44 px, eso ya no cabe en la pizarra.
 */
export const MAX_PROMPT_LENGTH = 800;
/** Lo mismo para la pista, que se lee con la pregunta ya abierta y el reloj corriendo. */
export const MAX_HINT_LENGTH = 300;
//# sourceMappingURL=constants.js.map